<template>
    <v-menu :disabled="disabled" offset-y nudge-bottom="16px">
        <template v-slot:activator="{ on: menu }">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn :disabled="disabled" small fab color="transparent" v-on="{ ...tooltip, ...menu }">
                        <v-icon color="white"> more_vert </v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('The_action_is_displayed') }}</span>
            </v-tooltip>
        </template>
        <v-list dense min-width="8em">
            <v-list-item v-for="item in menuItems" :key="item.text_key" @click="$emit('click-menu-item', item)">
                <v-list-item-content>
                    <v-list-item-title class="text-caption" v-text="$t(item.text_key)" />
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class MenuButtonTableHeader extends Vue {
    @Prop({ default: false }) readonly disabled: boolean;
    @Prop({ default: () => [] }) readonly menuItems: Array<{ text_key: string }>;
}
</script>
